import { render } from "./donut-chart.vue?vue&type=template&id=aa26c7c2"
import script from "./donut-chart.vue?vue&type=script&lang=js"
export * from "./donut-chart.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__